<template>
    <div>
      <UserModify></UserModify>
    </div>
  </template>
  
  <script>
  import UserModify from "@/components/user/UserModify.vue";
  
  export default {
    name: "UserModifyView",
    components: {
      UserModify
    }
  };
  </script>
  
  <style></style>
  